import chevronDownIcon from '../../../static/icons/ic_chevron_down_16.svg';
import chevronUpIcon from '../../../static/icons/ic_chevron_up_16.svg';
import MyMusicPlaceholderIcon from '../../../static/icons/ic_my_music_48.svg';
import VoiceTrackIcon from '../../../static/icons/ic_voicetrack_16.svg';
import * as Actions from '../../actions';
import { annotateIds, requestAnnotateAesopObjects } from '../../actions/Annotations';
import { ApiUpdateSettings } from '../../actions/Api';
import {
  addCollectionItem,
  getItemsByArtist,
  getSortedCollectionItems,
  getVersion,
  removeCollectionItem,
  setCollectionCurrentFilter,
  setCollectionCurrentFilterSort,
} from '../../actions/Collection';
import { openDropdown } from '../../actions/Dropdown';
import {
  closeMiniCoachmark,
  hidePodcastCollectionsCoachmark,
  openMiniCoachmark,
} from '../../actions/MiniCoachmark';
import {
  closeModal,
  openModal,
  openModalCoachmark,
  openModalCoachmarkWithButton,
} from '../../actions/Modal';
import { setMyStationsDisplaySettings, setMyStationsDisplayType } from '../../actions/MyStations';
import { annotatePlaylists, appendItemsToPlaylist, createPlaylist } from '../../actions/Playlist';
import BrowseCta from '../../components/Browse/BrowseCta';
import Button from '../../components/Button';
import ButtonLink, { ButtonLinkStyles } from '../../components/ButtonLink';
import Footer from '../../components/Footer/Footer';
import Form from '../../components/Form/Form';
import Grid from '../../components/Grid/Grid';
import InfiniteGrid from '../../components/Grid/InfiniteGrid';
import CatalogGridItem from '../../components/GridItemT3/CatalogGridItem';
import * as GridItemT3Constants from '../../components/GridItemT3/constants';
import GenreStationGridItem from '../../components/GridItemT3/GenreStationGridItem';
import MixedGridItem from '../../components/GridItemT3/MixedGridItem';
import PodcastEpisodeGridItem from '../../components/GridItemT3/PodcastEpisodeGridItem';
import PodcastProgramGridItem from '../../components/GridItemT3/PodcastProgramGridItem';
import StationGridItem from '../../components/GridItemT3/StationGridItem';
import Icon from '../../components/Icon/Icon';
import BgSetter from '../../components/lib/BgSetter';
import ButtonT3 from '../../components/lib/ButtonT3/ButtonT3';
import { ButtonT3Size, ButtonT3Theme } from '../../components/lib/ButtonT3/constants';
import FilterTypeNav from '../../components/lib/FilterTypeNav';
import GridItem from '../../components/lib/GridItem/GridItem';
import InfiniteScrolledList from '../../components/lib/InfiniteScrolledList';
import { Loading } from '../../components/lib/Loading/Loading';
import RowItem from '../../components/lib/RowItem/RowItem';
import SourceCardSubMenuItem from '../../components/lib/SourceCardMenuItem/SourceCardSubMenuItem';
import TextInput from '../../components/lib/TextInput/TextInput';
import MiniCoachmark from '../../components/Overlay/MiniCoachmark';
import ResizeMeasurer from '../../components/ResizeMeasurer/ResizeMeasurer';
import MixedRowItem from '../../components/RowItemT3/MixedRowItem';
import determineShouldDropSearchToNextLine from '../../components/SearchResponsiveHelper/SearchResponsiveHelper';
import ShuffleButton from '../../components/ShuffleButton/ShuffleButton';
import * as Constants from '../../constants';
import ApiActions, { ApiEndpoints } from '../../constants/ApiActions';
import { BgSettings, KeyCodes } from '../../constants/App';
import { CatalogActions } from '../../constants/Catalog';
import {
  CollectionActions,
  messages,
  MyMusicSorts,
  MyPodcastSorts,
  v7SortingMap,
} from '../../constants/Collection';
import DropdownConstants from '../../constants/Dropdown';
import { FilterNavTypes } from '../../constants/FilterTypeNav';
import {
  messages as MiniCoachmarkMessages,
  MiniCoachmarkTypes,
} from '../../constants/MiniCoachmark';
import {
  messages as MyStationsMessages,
  MyStationDisplayTypes as MyStationsSorts,
  MyStationSortTypes as MyCollectedStationSorts,
  SORT_BY as MyStationListSorts,
} from '../../constants/MyStations';
import { PremiumWelcomeModalSubtype } from '../../constants/Overlay';
import { messages as playlistMessages } from '../../constants/PlaylistT3';
import QA from '../../constants/QATags';
import { PandoraTypes, PandoraTypeSources, SourceTypes } from '../../constants/SourceTypes';
import { remToPixelRatio } from '../../constants/Styling';
import ViewActions from '../../constants/ViewActions';
import BrowseGenreBestOfPandora from '../../containers/BrowseGenres/BrowseGenreBestOfPandora';
import { AsyncComponent, AsyncDomain } from '../../domains';
import { getInDomain } from '../../domains/externalUtils';
import { GraphQL } from '../../graphql';
import Api from '../../lib/Api';
import { getArt } from '../../lib/ArtUtils';
import { getPollCollectionInterval } from '../../lib/configuration/TunerVarUtils';
import { AppContextIntegrationData } from '../../lib/Context';
import { getAllAnnotations, getAnnotationsById, getStationEntities } from '../../lib/EntityUtils';
import { getDataFetcher, getOnRandomAccessInfiniteScroll } from '../../lib/InfiniteScrollUtils';
import {
  getAuthToken,
  getCurrentListenerIdFromState,
  hasPremiumFeatures,
  hasSeenWebPremiumWelcome,
} from '../../lib/ListenerUtils';
import { getMyStationsDisplay, getMyStationsInitialSort } from '../../lib/MyStationsUtils';
import {
  fetchedAnnotationMyCollectionVerifier,
  fetchedAnnotationMyMusicVerifier,
  getLoadedPages,
  getOffsetToFetchWith,
  getPagesToFetchBasedOnIndicesInView,
  getPagesToFetchBasedOnItemsInView,
  getPlaceholderShift,
} from '../../lib/RandomAccessUtils';
import { createReducer } from '../../lib/ReducerUtils';
import { isRadioOnly, isRemoved, isRetired, isUnavailable } from '../../lib/RightsUtils';
import {
  getBrowsePodcastsPath,
  getCollectionPath,
  getCurrentPathnameFromState,
  getMyMusicPath,
} from '../../lib/RouteUtils';
import { getSourceCardMenuItems } from '../../lib/SourceCardUtils';
import {
  getMemoizedFilterTypes,
  getPandoraTypeFromPandoraId,
  isPodcastPandoraType,
  isStationType,
} from '../../lib/SourceTypeUtils';
import { alphabetizeComparator } from '../../lib/StringUtils';
import { formatTime, getNow } from '../../lib/TimeUtils';
import { createBEM } from '../../lib/utils/css';
import { tryCall } from '../../sagas/Helpers';
import { taskManagerSpawnFactory } from '../../sagas/Helpers/SpawnedTaskManager';
import { putAndWait } from '../../sagas/TaskManager';
import * as Services from '../../services';
import { getStore } from '../../store/StoreAccessor';
import { MyMusicSortDropdownKey } from '../../tools/Dropdowns/MyMusicSortDropdown';
import Logger from '../../tools/Logger';
import createFilter from '../../tools/ReduxPersistFilter';
import * as Utils from '../../utils';

const apiRequest = Api.apiRequest;
export {
  Actions,
  addCollectionItem,
  alphabetizeComparator,
  annotateIds,
  annotatePlaylists,
  ApiActions,
  ApiEndpoints,
  apiRequest,
  ApiUpdateSettings,
  AppContextIntegrationData,
  appendItemsToPlaylist,
  AsyncComponent,
  AsyncDomain,
  BgSetter,
  BgSettings,
  BrowseCta,
  BrowseGenreBestOfPandora,
  Button,
  ButtonLink,
  ButtonLinkStyles,
  ButtonT3,
  ButtonT3Size,
  ButtonT3Theme,
  CatalogActions,
  CatalogGridItem,
  chevronDownIcon,
  chevronUpIcon,
  closeMiniCoachmark,
  closeModal,
  CollectionActions,
  Constants,
  createBEM,
  createFilter,
  createPlaylist,
  createReducer,
  determineShouldDropSearchToNextLine,
  DropdownConstants,
  fetchedAnnotationMyCollectionVerifier,
  fetchedAnnotationMyMusicVerifier,
  FilterNavTypes,
  FilterTypeNav,
  Footer,
  Form,
  formatTime,
  GenreStationGridItem,
  getAllAnnotations,
  getAnnotationsById,
  getArt,
  getAuthToken,
  getBrowsePodcastsPath,
  getCollectionPath,
  getCurrentListenerIdFromState,
  getCurrentPathnameFromState,
  getDataFetcher,
  getInDomain,
  getItemsByArtist,
  getLoadedPages,
  getMemoizedFilterTypes,
  getMyMusicPath,
  getMyStationsDisplay,
  getMyStationsInitialSort,
  getNow,
  getOffsetToFetchWith,
  getOnRandomAccessInfiniteScroll,
  getPagesToFetchBasedOnIndicesInView,
  getPagesToFetchBasedOnItemsInView,
  getPandoraTypeFromPandoraId,
  getPlaceholderShift,
  getPollCollectionInterval,
  getSortedCollectionItems,
  getSourceCardMenuItems,
  getStationEntities,
  getStore,
  getVersion,
  GraphQL,
  Grid,
  GridItem,
  GridItemT3Constants,
  hasPremiumFeatures,
  hasSeenWebPremiumWelcome,
  hidePodcastCollectionsCoachmark,
  Icon,
  InfiniteGrid,
  InfiniteScrolledList,
  isPodcastPandoraType,
  isRadioOnly,
  isRemoved,
  isRetired,
  isStationType,
  isUnavailable,
  KeyCodes,
  Loading,
  Logger,
  messages,
  MiniCoachmark,
  MiniCoachmarkMessages,
  MiniCoachmarkTypes,
  MixedGridItem,
  MixedRowItem,
  MyCollectedStationSorts,
  MyMusicPlaceholderIcon,
  MyMusicSortDropdownKey,
  MyMusicSorts,
  MyPodcastSorts,
  MyStationListSorts,
  MyStationsMessages,
  MyStationsSorts,
  openDropdown,
  openMiniCoachmark,
  openModal,
  openModalCoachmark,
  openModalCoachmarkWithButton,
  PandoraTypes,
  PandoraTypeSources,
  playlistMessages,
  PodcastEpisodeGridItem,
  PodcastProgramGridItem,
  PremiumWelcomeModalSubtype,
  putAndWait,
  QA,
  removeCollectionItem,
  remToPixelRatio,
  requestAnnotateAesopObjects,
  ResizeMeasurer,
  RowItem,
  Services,
  setCollectionCurrentFilter,
  setCollectionCurrentFilterSort,
  setMyStationsDisplaySettings,
  setMyStationsDisplayType,
  ShuffleButton,
  SourceCardSubMenuItem,
  SourceTypes,
  StationGridItem,
  taskManagerSpawnFactory,
  TextInput,
  tryCall,
  Utils,
  v7SortingMap,
  ViewActions,
  VoiceTrackIcon,
};
